<template>
    <div>
        <v-data-iterator
                :total-items="record_count"
                :pagination.sync="pagination"
                :items="items"
                :content-tag="content_tag"
                :no-data-text="$t('general.no_data_available')"
                :rows-per-page-text="$t('general.items_per_page')"
                :rows-per-page-items="rows_per_page_items"
                :content-class="content_class"
                v-show="!loading"

        >
            <template
                    slot="item"
                    slot-scope="props"
            >
                <slot :item="props.item"></slot>
            </template>

        </v-data-iterator>

        <div class="text-xs-center">
            <v-progress-circular v-show="loading" color="grey" :indeterminate="true"></v-progress-circular>
        </div>
    </div>

</template>

<script>
    import RequestHandler from '~/utils/request-handler'
    import { CancelToken } from 'axios'

    export default {
        name: "ajax-data-iterator",
        props: {
            get_url: String,
            url_query: Object,
            content_class: String,
            content_tag: {
                type: String,
                default: "v-list"
            },
            content_props: String,
            response_callback_function: {
                type: Function,
                default: function(item){}
            },
            rows_per_page_items: {
                type: Array,
                default: () => [10,25,{"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}]
            },
            item_handle_function: {
                type: Function,
                default: function(item){return item}
            }
        },
        data() {
            return {
                items: [],
                loading: true,
                record_count: 0,
                pagination: {},
                cancel_request: () => {}
            };
        },
        methods: {
            updateItem(index, item) {
                if(this.items[index]){
                    this.items[index] = _.extend({}, item);
                }
            },
            itemHandler(item) {
                return this.item_handle_function(item);
            },
            responseCallback(data) {
                this.response_callback_function(data);
            },
            getDataFromApi() {
                let me = this;
                const { page, rowsPerPage } = this.pagination;

                me.cancel_request();

                let config = {
                    cancelToken: new CancelToken(function executor(c) {
                        me.cancel_request = c;
                    })
                };

                let params = {
                    page: page,
                    record_per_page: rowsPerPage
                };

                if(!_.isEmpty(this.url_query)){
                    params = _.extend(params, this.url_query);
                }

                this.loading = true;
                new RequestHandler.Get(this.get_url, params, {
                    'success': function(data) {
                        me.responseCallback(data);
                        me.record_count = parseInt(data['record_count']);
                        let processed_items = [];
                        _.each(data['data'], function(item){
                            processed_items.push(me.itemHandler(item));
                        });
                        me.items = processed_items;
                        me.loading = false;
                    }
                }, config);
            }
        },
        watch: {
            pagination: {
                handler () {
                    this.getDataFromApi();
                },
                deep: true
            }
        }
    }
</script>

<style scoped>

</style>